import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { t } from "i18next";
import { startLogout } from "./authActions";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";

export const startLoadingConfigurations = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CONFIGURATION}`, "get");
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingConfigurations(body.configurations));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingConfigurations = (configurations) => ({
  type: types.CONFIGURATION_START_LOADING,
  payload: configurations,
});

export const startLoadingConfigurationsPaginated = (page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CONFIGURATION}`, `get/${page}/${size}`);
    const body = await resp.json();

     debugLogActions(':: configurationActions, startLoadingConfigurationsPaginated', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingConfigurationsPaginated(body.configurationPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingConfigurationsPaginated = (configurationPaginated) => ({
  type: types.CONFIGURATION_START_LOADING_PAGINATED,
  payload: configurationPaginated,
});

export const selectConfigurations = (configuration) => ({
  type: types.CONFIGURATION_SELECT,
  payload: configuration,
});

export const configurationClean = () => ({
  type: types.CONFIGURATION_CLEAN,
});

export const configurationStartDelete = (id) => {
  return async (dispatch) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_CONFIGURATION}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {

              debugLogActions(':: configurationActions, configurationStartDelete', { 'body': body });

              if (body.ok) {
                dispatch(configurationDeleted(id));
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: configurationActions, configurationStartDelete', { 'error': error });
    }
  };
};

const configurationDeleted = (id) => {
  return {
    type: types.CONFIGURATION_DELETE,
    payload: id,
  };
};

export const startSearchingConfigurationsPaginated = (textSearch, page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CONFIGURATION}`,
      `search/${textSearch}/${page}/${size}`
    );
    const body = await resp.json();

    debugLogActions(':: configurationActions, startSearchingConfigurationPaginated', { 'body': body });

    if (body.ok) {
      dispatch(searchingConfigurationsPaginated(body.configurationsPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const searchingConfigurationsPaginated = (configurationsPaginated) => ({
  type: types.CONFIGURATION_START_SEARCH_PAGINATED,
  payload: configurationsPaginated,
});

export const cleanSearchingConfigurationsPaginated = () => ({
  type: types.CONFIGURATION_CLEAN_SEARCH_PAGINATED,
});

export const configurationStartUpdate = (configuration, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_CONFIGURATION}`,
        `update/${configuration.id}`,
        configuration,
        "PUT"
      );
      const body = await resp.json();

      debugLogActions(':: configurationActions, configurationStartUpdate', { 'body': body });

      if (body.ok) {
        dispatch(configurationUpdated(configuration));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              navigate("/admin-configuration");
            }, 5000);
          }
        });

      } else {
        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: configurationActions, configurationStartUpdate', { 'error': error });
    }
  };
};

/**
 * Funcion para actualizar un evento en el store
 * @param {*} configuration
 * @returns
 */
const configurationUpdated = (configuration) => {
  return {
    type: types.CONFIGURATION_UPDATE,
    payload: configuration,
  };
};

export const configurationStartRegister = (configuration, navigate) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CONFIGURATION}`,
      "add",
      configuration,
      "POST"
    );

    const body = await resp.json();

    debugLogActions(':: configurationActions, configurationStartRegister', { 'body': body });

    if (body.ok) {
      dispatch(configurationRegister(body.configuration));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            navigate("/admin-configuration");
          }, 5000);
        }
      });
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const configurationRegister = (configuration) => ({
  type: types.CONFIGURATION_START_REGISTER,
  payload: configuration,
});

export const configurationSetSearchText = (searchText) => ({
  type: types.CONFIGURATION_SET_SEARCH_TEXT,
  payload: searchText,
});

export const configurationCleanSearchText = () => ({
  type: types.CONFIGURATION_SET_SEARCH_TEXT,
});

/** Revision */
export const startLoadingConfigurationsAll = (type) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CONFIGURATION}`, `get`);
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingConfigurationAll(body.configurations));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const loadingConfigurationAll = (configurations) => ({
  type: types.CONFIGURATION_START_LOADING_ALL,
  payload: configurations,
});
